// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"bc6e0e0b","212":"4af02abf","396":"07423149","421":"25b1d5ea","655":"d3e4275c","855":"8b8c8408"}[chunkId] + ".chunk.css";
};